import PageService from '@/services/page.service'

export const getList = ({ commit }) => {
  return PageService.getBlogPosts().then((response) => {
    commit('setBlogPosts', response.data)
  })
}
